if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

/**
 * Initialize sticky header scroll effects
 * The wrapper is already in theme.liquid
 */
function initStickyHeader() {
  const wrapper = document.querySelector('.header-group-wrapper');
  
  if (!wrapper) return;
  
  // Add scroll listener for shadow effect
  let ticking = false;
  const handleScroll = () => {
    if (window.scrollY > 5) {
      wrapper.classList.add('is-scrolled');
    } else {
      wrapper.classList.remove('is-scrolled');
    }
  };
  
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  
  // Initial check
  handleScroll();
}

// Run immediately if DOM is ready, otherwise wait
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyHeader);
} else {
  initStickyHeader();
}

/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
      this.scrollPosition = 0;
    }
    
    connectedCallback() {
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      // Escape key handler
      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          if (this.toggle && this.toggle.classList.contains('active')) {
            this.closeMenu();
          }
        }
      });

      // Mobile toggle click handler (only if toggle exists)
      if (this.toggle) {
        const mobileToggleBtn = this.toggle.querySelector('.mobile-toggle');
        if (mobileToggleBtn) {
          mobileToggleBtn.addEventListener('click', (e) => {
            // Always prevent default to stop auto-scroll behavior
            e.preventDefault();
            e.stopPropagation();
            
            if (this.toggle.classList.contains('active')) {
              this.closeMenu();
            } else {
              this.openMenu();
            }
            window.dispatchEvent(new Event('resize.resize-select'));
          });
        }
        
        // Prevent details toggle event from causing scroll
        this.toggle.addEventListener('toggle', (e) => {
          e.preventDefault();
          e.stopPropagation();
        });
      }

      // Mobile menu buttons
      if (this.menu) {
        this.menu.querySelectorAll('summary').forEach(summary => {
          summary.addEventListener('click', this.onSummaryClick.bind(this));
        });
      }
    }

    openMenu() {
      // Open details element
      this.toggle.setAttribute('open', '');
      
      // Simple overflow hidden - no position changes
      document.body.classList.add('overflow-hidden');
      document.documentElement.style.overflow = 'hidden';
      
      setTimeout(() => {
        this.toggle.classList.add('active');
      });
    }
    
    closeMenu() {
      this.toggle.classList.remove('active');
      
      // Restore scroll
      document.body.classList.remove('overflow-hidden');
      document.documentElement.style.overflow = '';
      
      this.closeAnimation(this.toggle);
    }

    onSummaryClick(event) {
      // Prevent default to stop auto-scroll behavior
      event.preventDefault();
      event.stopPropagation();
      
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      
      if (isOpen) {
        detailsElement.classList.remove('submenu-open');
        detailsElement.removeAttribute('open');
      } else {
        detailsElement.classList.add('submenu-open');
        detailsElement.setAttribute('open', '');
      }
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
      this.submenus = this.querySelectorAll('.thb-full-menu .menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      document.fonts.ready.then(function () {
        window.addEventListener('resize', debounce(function () {
          _this.resizeSubMenus();
        }, 100));
        _this.resizeSubMenus();
      });
    }
    
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
